import { MutationTree } from 'vuex';

import { ToastStateI } from './state';

const mutations: MutationTree<ToastStateI> = {
  setToast(state: ToastStateI, payload: ToastStateI) {
    state.timeout = payload.timeout ? payload.timeout : 3000;
    state.message = payload.message;
    state.type = payload.type;
    state.show = true;

    // update the timeout every millisecond
    const intervalId = setInterval(() => {
      if (!state.timeout) state.timeout = 3000;
      state.timeout -= 10;
      if (state.timeout <= 0) {
        clearInterval(intervalId);
        state.timeout = 0;
        state.show = false;
      }
    }, 10);
  },
  closeToast(state: ToastStateI) {
    state.show = false;
    state.message = '';
    state.type = '';
    state.timeout = 0;
  },
  setMessage(state: ToastStateI, payload: string) {
    state.message = payload;
    state.show = true;
    state.timeout = 3000;
    state.type = 'info';
  },
};

export default mutations;
